exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nowrap{white-space:nowrap!important}.ic_birthday img,.ic_caledar img,.ic_phone img,.ic_school .ic_mail img{width:16px;height:16px}@media (max-width:414px){.nowrap{white-space:normal!important}}@media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:3){.col-xs-1{padding-right:9px!important}}@media only screen and (device-width:375px) and (device-height:667px){.col-xs-1{padding-right:9px!important}}@media only screen and (device-width:320px) and (device-height:568px){.col-xs-1{padding-right:8px!important}}@media only screen and (device-width:360px) and (device-height:640px){.col-xs-1{padding-right:11px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53df0bd0","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserProfile/UserInfo.vue
// module id = 1089
// module chunks = 0